import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import PackageCard from "@/components/PackageCard";

export default function PackagesPage() {
  const { t } = useLang();
  const [packages, setPackages] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    api.get("/packages").then(({ data }) => setPackages(data)).catch(() => {});
  }, []);

  const cats = ["All", ...Array.from(new Set(packages.map((p) => p.category)))];
  const shown = cat === "All" ? packages : packages.filter((p) => p.category === cat);

  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
      <div className="text-center mb-12">
        <span className="text-xs tracking-[0.2em] uppercase text-gold">{t("our_services")}</span>
        <h1 className="font-display text-4xl sm:text-5xl text-zinc-900 mt-3">{t("nav_packages")}</h1>
        <p className="text-zinc-600 mt-4 max-w-lg mx-auto">{t("services_sub")}</p>
      </div>

      <div className="flex flex-wrap justify-center gap-2 mb-12">
        {cats.map((c) => (
          <button
            key={c}
            onClick={() => setCat(c)}
            data-testid={`cat-filter-${c}`}
            className={`px-5 py-2 rounded-full text-sm transition-colors border ${
              cat === c ? "gold-gradient text-white border-transparent font-semibold" : "border-pink-300 text-zinc-700 hover:border-gold/40"
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {shown.map((p, i) => (
          <PackageCard key={p.id} pkg={p} index={i} />
        ))}
      </div>
    </div>
  );
}
